<template>
  <div class="h-full w-full flex flex-col justify-between overflow-y-auto text-app-color pr-8 -mr-8">
    <div class="w-full max-w-300 mx-auto md:max-w-full md:px-100 py-35 md:py-67">
      <div class="flex items-center md:hidden text-app-color" @click="back">
        <i class="text-12 mr-10 icon-keyboard-arrow-left opacity-50" />
        <p class="text-opacity-80">Back</p>
      </div>

      <h2 class="text-app-color mb-35 font-bold text-25 md:text-21 mt-20">{{ title }}</h2>

      <draggable
        v-if="orderedTemplates.length"
        v-model="orderedTemplates"
        :delay="300"
        :delay-on-touch-only="true"
        :force-fallback="true"
        :disabled="dragDisabled"
        item-key="id"
        class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 md:gap-20"
        @end="onDragEnd"
        @start="onStart"
      >
        <template #item="{ element }">
          <TemplateItem
            :type="type"
            :template="element"
            @setTemplate="setTemplate"
            @dragStop="dragDisabled = true"
            @dragStart="dragDisabled = false"
          />
        </template>
      </draggable>

      <div v-else>No templates</div>
    </div>
  </div>
</template>

<script>
import { computed, defineComponent, ref } from 'vue'
import { useStore } from 'vuex'
import TemplateItem from '@/components/templates/TemplateItem'

import draggable from 'vuedraggable'
import draggableMixin from '@/mixins/draggable'
import { generateHTML } from '@/core/helper-functions'
import { templateService } from '@/services'

export default defineComponent({
  components: { TemplateItem, draggable },

  mixins: [draggableMixin],

  props: {
    editor: Object,
    title: String,
    type: String
  },

  emits: ['back'],

  setup (props, { emit }) {
    const { state, dispatch, commit } = useStore()

    const dragDisabled = ref(false)
    const templates = computed(() => state.template.templates)
    const settings = computed(() => state.settings.settings)
    const currentProject = computed(() => state.project.currentProject)

    dispatch('getTemplates', props.type)

    const orderedTemplates = computed({
      get: () => {
        return templates.value
      },
      set: (value) => {
        const ids = value.map(item => item.id)
        commit('setTemplates', value)

        dispatch('orderTemplates', { ids: ids })
      }
    })

    function back () {
      emit('back')
    }

    function setTemplate (templateId) {
      commit('loading', true)

      const project = currentProject.value

      templateService.paste({
        templateId: templateId,
        projectId: project.id
      }).then(({ data }) => {
        props.editor.chain().setContent(data.project.body).run()
        commit('setCurrentProject', {
          ...project,
          ...data.project,
          html: generateHTML(data.project.body, settings.value, data.project.title)
        })
        setTimeout(() => {
          const el = document.querySelector('.title')
          if (el) el.scrollIntoView(false)
          commit('toggleTemplateModal', false)
        }, 400)
      })
    }

    return {
      templates,
      orderedTemplates,
      dragDisabled,
      setTemplate,
      back
    }
  }
})
</script>
